import types from './types';

const INITIAL_STATE = {
    isPosting: false,

    result: [],
};

const authConfirmedReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.POST_CONFIRMED_AUTH_REQUEST:
        return {
            ...state,
            result: [],
            isPosting: true,
        };

    case types.POST_CONFIRMED_AUTH_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isPosting: false,
        };

    case types.POST_CONFIRMED_AUTH_FAILURE:
        return {
            ...state,
            result: [],
            isPosting: false,
        };

    default:
      return state;
  }
};

export default authConfirmedReducer;
